import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AccountingCloseError} from "@app/shared/classes/accounting-close-error";
import {PrimeNgConfig, TableColumn} from "@app/shared";

@Component({
  selector: 'app-entity-error',
  templateUrl: './entity-error.component.html',
  styleUrls: ['./entity-error.component.css']
})
export class EntityErrorComponent implements OnInit {

  @Input() entityErrors: Array<AccountingCloseError>;
  @Input() displayError: boolean;
  @Output() handler: EventEmitter<boolean> = new EventEmitter<boolean>();

  PrimeNgConfig = PrimeNgConfig;
  tableColumns: TableColumn[];

  constructor() {
  }


  ngOnInit() {
    this.initTableColumns();
  }

  onClickClose(): void {
    this.displayError = false;
    this.handler.emit(false);
  }

  private initTableColumns(): void {
    this.tableColumns = [
      {field: 'index', header: '', columnStyle: "width:10%"},
      {field: 'evidence', header: 'Detail', columnStyle: "width:90%"},
    ];
  }
}
